import { Routes } from '@angular/router';

export const helpCenterRoutes: Routes = [
  {
    path: 'help',
    loadComponent: () => import('./help-center.component').then(m => m.HelpCenterComponent)
  },
  {
    path: 'help/:manualId',
    loadComponent: () => import('./help-manual.component').then(m => m.HelpManualComponent)
  }
];
